module.exports = __webpack_public_path__ + "img/resource3.45807985.jpg";